// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"143":"d7413e9c","671":"c6f9a5c1","934":"b86d70f0"}[chunkId] + ".css";
};